/** 展示版本号最大长度（与后端 MaterialVersionUtil.MAX_LABEL_LENGTH 保持一致） */
export const MAX_VERSION_LABEL_LENGTH = 20;

/** 规范化版本号：去空格、补 v 前缀 */
export function normalizeVersionLabel(raw: string): string {
  let s = raw.trim();
  if (!s) return '';
  if (!/^v/i.test(s)) s = `v${s}`;
  return s.length === 1 ? s.toLowerCase() : `v${s.slice(1)}`;
}

/** 校验版本号格式：v1、v2、v1.0、v1.1 等 */
export function isValidVersionLabel(raw: string): boolean {
  const s = normalizeVersionLabel(raw);
  return s.length > 0
    && s.length <= MAX_VERSION_LABEL_LENGTH
    && /^v\d+(\.\d+)*$/i.test(s);
}

/** 展示用版本号（已含 v 前缀则不再重复添加） */
export function displayVersionLabel(v?: string | number | null): string {
  if (v == null || v === '') return 'v1';
  const s = String(v).trim();
  const normalized = /^v/i.test(s) ? normalizeVersionLabel(s) : normalizeVersionLabel(`v${s}`);
  return isValidVersionLabel(normalized) ? normalized : 'v1';
}
